<template>
  <div>
    <div class="mt-15 container card_container">
      <modal-lista-sede
          :presaInCarico="presaInCarico"
          @onRifiutaPrimaDisponibilita="onRifiutaPrimaDisponibilita"
          @onSedeSelezionata="onSedeSelezionata"
          @setLoading="setLoading"
          :listaSedi="listaSedi"
          ref="modalListaSede"
          id="modalListaSede"
          @chiudi="chiudi"
      ></modal-lista-sede>
      <modal-cambia-data-disp @getData="getData"></modal-cambia-data-disp>
      <anagrafica :codiceImpegnativa="presaInCarico.nre" :priorita="presaInCarico.classePriorita" :assistito="assistito"></anagrafica>
      <div class="separator border-4 my-3"></div>
      <h3 class="mb-5 titolo"><i class="fas fa-clipboard-list"></i> disponibilità</h3>

      <datatable-disponibilita :esamiDisponibili="jsonData.prossimiEsamiDisponibili "></datatable-disponibilita>
      <b-container class="bv-example-row">
        <b-row>
          <b-col>
            <a href="#/prenota">
              <b-button variant="outline-secondary" class="w-100" @click="onAnnulla"
                ><i class="fas fa-trash"></i>
                Annulla
              </b-button>
            </a>
          </b-col>
          <b-col>
            <b-button class="w-100 btn-outline" v-b-modal.modalListaSede
            ><i class="fas fa-calendar-minus"></i>
              Altre Proposte
            </b-button>
          </b-col>
          <b-col>
            <b-button v-b-modal.modal-5 class="btn-outline"><i class="fas fa-calendar-plus"></i> Cambia data disponibilità </b-button>
          </b-col>
          <b-col></b-col>
          <b-col>
            <b-button class="w-100 btn-outline" @click="onConfermaPrenotazione"> Conferma <i class="fas fa-clipboard-check"></i></b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" color="#274561" loader="dots" :height="120" :width="120"></loading>
  </div>
</template>
<script>
import anagrafica from "../anagrafica/anagrafica.vue";
import Loading from "vue-loading-overlay";
import DatatableDisponibilita from "../datatable/datatableDisponibilita.vue";
import axios from "axios";
import modalCambiaDataDisp from "../modal/modalCambiaDataDisp.vue";
import modalListaSede from "../modal/modalListaSede.vue";
import EngiService from "@/services/engiService";
import getVocabolario from "@/utilities/utilityCercaVocabolario";

export default {
  props: {
    assistito: Object,
    presaInCarico: Object,
    esamiDisponibili: Object,
    sedeSelezionata: String,
    listaSedi: Array
  },
  components: {
    anagrafica,
    DatatableDisponibilita,
    modalCambiaDataDisp,
    modalListaSede,
    Loading,
  },
  data() {
    return {
      showModal: false,
      messaggioPrePrenotazione: JSON.parse(sessionStorage.getItem("messaggiUtente")).messaggioPrePrenotazione,
      pathResourceAnnulla: "/api/v2.0/appecupt/aslengi/annullaprenotazionesospesa",
      pathResourceProssimaDisponibilita: "/api/v2.0/appecupt/aslengi/ricercaDisponibilitaProssima/",
      pathResourceCercaData: "/api/v2.0/appecupt/aslengi/ricercaDisponibilitaProssima/",
      pathResourceConferma: "/api/v2.0/appecupt/aslengi/confermaappuntamento",
      jsonData: {
        prossimiEsamiDisponibili: [],
      },
      token: null,
      tokenLogin: null,
      isLoading: false,
    };
  },
  mounted: function () {
    let me = this;
    me.jsonData.prossimiEsamiDisponibili = me.esamiDisponibili.prestazioniDisponibili;
    me.loadData();
  },
  methods: {
    onConfermaPrenotazione() {
      let me = this;
      me.$bvModal
        .msgBoxConfirm(me.messaggioPrePrenotazione, {
          title: "Conferma Prenotazione",
          footerClass: "p-2",
          centered: true,
          cancelTitle: "Chiudi",
          okTitle: "Conferma",
        })
        .then(async (response) => {
          if(response) {
            try {
              const parametriConferma = {
                index: 0,
              };
              me.isLoading = true;
              const responseConfermaPrenotazione = await EngiService.confermaPrenotazioneNre(parametriConferma);
              if (responseConfermaPrenotazione.data.stato === 200) {
                this.$bvModal
                    .msgBoxOk(responseConfermaPrenotazione.data.data, {
                      title: "Esito Prenotazione",
                      size: "md",
                      okVariant: "outline-success",
                      headerClass: "vv-msg-header-success",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                    })
                    .then(() => {
                      me.$emit("setStep", 0);
                    })
                    .catch(() => {
                      me.$emit("setStep", 0);
                    });
              } else {
                this.$bvModal
                    .msgBoxOk(responseConfermaPrenotazione.data.errore, {
                      title: "Errore",
                      size: "sm",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                    })
                    .then(() => {
                    })
                    .catch((err) => {
                      console.log(err);
                    });
              }
              me.isLoading = false;
            } catch (e) {
              me.isLoading = false;
              me.$bvModal
                  .msgBoxOk(e, {
                    title: "Errore",
                    size: "md",
                    okVariant: "outline-danger",
                    headerClass: "vv-msg-header-danger",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then(() => {
                  })
                  .catch(() => {
                  });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      let me = this;
      me.token = sessionStorage.getItem("tokenWSO2");
      me.tokenLogin = sessionStorage.getItem("loginData");
    },
    onAnnulla() {
      let me = this;
        let msg = getVocabolario("messaggioAnnullaProceduraPrenotazione")
        if(!msg)
            msg = "Sei sicuro di voler annullare la procedura di Prenotazione dell'impegnativa  "
      me.$bvModal
        .msgBoxConfirm(msg + me.presaInCarico.nre + " ?", {
          title: "Conferma Annullamento",
          footerClass: "p-2",
          centered: true,
          cancelTitle: "Chiudi",
          okTitle: "Conferma",
        })
        .then(async (response) => {
          if (response) {
            me.isLoading = true;
            try {
              await EngiService.annullaPrenotazioneSospesa()
                .then(() => {
                  me.isLoading = false;
                  me.$emit("setStep", 0);
                })
                .catch((error) => {
                  me.isLoading = false;
                  console.log(error);
                  this.$bvModal
                    .msgBoxOk(error.response, {
                      title: "Errore",
                      size: "sm",
                      okVariant: "outline-danger",
                      headerClass: "vv-msg-header-danger",
                      footerClass: "p-2 border-top-0",
                      centered: true,
                    })
                    .then(() => {})
                    .catch(() => {});
                });
            } catch (e) {
              me.isLoading = false;
              me.$bvModal
                .msgBoxOk(e, {
                  title: "Errore",
                  size: "md",
                  okVariant: "outline-danger",
                  headerClass: "vv-msg-header-danger",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then(() => {})
                .catch(() => {});
            }
          }
        });
    },
    onProssimaDisponibilita() {
      let me = this;
      let link = process.env.VUE_APP_URL_BACKEND + me.pathResourceProssimaDisponibilita + me.sedeSelezionata;
      me.isLoading = true;
      const bodyProssimaDispSede = [];

      me.presaInCarico.prestazioni.forEach((item) => {
        bodyProssimaDispSede.push({
          idPrestazione: item.idPrestazione,
          reparto: item.reparto,
          dataAppuntamento: me.esamiDisponibili[0].dataAppuntamento,
        });
      });
      axios
        .post(link, bodyProssimaDispSede, {
          headers: {
            //Authorization: `Bearer ${me.token}`,
            "x-access-token": me.tokenLogin,
            struttura: process.env.VUE_APP_STRUTTURA,
          },
        })
        .then((response) => {
          if (response.data.stato === 200) {
            me.$emit("getProssimaDisponibilita", (me.jsonData.prossimiEsamiDisponibili = response.data.data));

            me.isLoading = false;
          } else {
            this.$bvModal
              .msgBoxOk(response.data.errore, {
                title: "Errore",
                size: "sm",
                okVariant: "outline-danger",
                headerClass: "vv-msg-header-danger",
                footerClass: "p-2 border-top-0",
                centered: true,
              })
              .then(() => {})
              .catch(() => {});
          }
          me.isLoading = false;
        });
    },
    async getData(data) {
      let me = this;
      me.isLoading = true;
      const bodyProssimaDispSede = [];
      me.presaInCarico.prestazioni.forEach((item) => {
        bodyProssimaDispSede.push({
          idPrestazione: item.idPrestazione,
          reparto: item.reparto,
        });
      });
      try {
        const responseDisponibilitaProssima = await EngiService.ricercaDisponibilitaProssimaNre(me.sedeSelezionata, data, bodyProssimaDispSede);
        if (responseDisponibilitaProssima.data.stato === 200) {
          console.log("nuovidati:", responseDisponibilitaProssima.data.data);
          me.$emit("getProssimaDisponibilita", (me.jsonData.prossimiEsamiDisponibili = responseDisponibilitaProssima.data.data.prestazioniDisponibili));
          me.isLoading = false;
        } else {
          this.$bvModal
            .msgBoxOk(responseDisponibilitaProssima.data.errore, {
              title: "Errore",
              size: "sm",
              okVariant: "outline-danger",
              headerClass: "vv-msg-header-danger",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then(() => {})
            .catch((err) => {
              console.log(err);
            });
        }
        me.isLoading = false;
      } catch (e) {
        me.isLoading = false;
        me.$bvModal
          .msgBoxOk(e, {
            title: "Errore",
            size: "md",
            okVariant: "outline-danger",
            headerClass: "vv-msg-header-danger",
            footerClass: "p-2 border-top-0",
            centered: true,
          })
          .then(() => {
            me.isLoading = false;
          })
          .catch(() => {
            me.isLoading = false;
          });
      }
    },
    setLoading(value) {
      let me = this;
      me.isLoading = value;
    },
    onSedeSelezionata(sedeSelezionata) {
      let me = this;
      me.$emit("onSedeSelezionata", sedeSelezionata);
    },
    chiudi() {
      this.$bvModal.hide('modalListaSede');
    },
    onRifiutaPrimaDisponibilita(primaDispSede) {
      let me = this;
      console.log("test: ", primaDispSede);
      me.$emit("getProssimaDisponibilita", (me.jsonData.prossimiEsamiDisponibili = primaDispSede.prestazioniDisponibili));
      this.chiudi();
      me.isLoading = false;
    },
  },
};
</script>
<style scoped>
.center {
  margin: auto;
  width: 60%;
  padding: 10px;
}
</style>
